import React from "react"

// Types
import { IIconProps } from "./Icon"

const EnvelopeIcon: React.FCS<IIconProps> = ({
  className,
  width,
  height,
  color,
}) => (
  <svg
    className={className}
    style={{
      width: `${String(width)}px`,
      height: `${String(height)}px`,
    }}
    width="32"
    height="24"
    viewBox="0 0 32 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 4C0 2.93913 0.421427 1.92172 1.17157 1.17157C1.92172 0.421427 2.93913 0 4 0H28C29.0609 0 30.0783 0.421427 30.8284 1.17157C31.5786 1.92172 32 2.93913 32 4V20C32 21.0609 31.5786 22.0783 30.8284 22.8284C30.0783 23.5786 29.0609 24 28 24H4C2.93913 24 1.92172 23.5786 1.17157 22.8284C0.421427 22.0783 0 21.0609 0 20V4ZM4 2C3.46957 2 2.96086 2.21071 2.58579 2.58579C2.21071 2.96086 2 3.46957 2 4V4.434L16 12.834L30 4.434V4C30 3.46957 29.7893 2.96086 29.4142 2.58579C29.0391 2.21071 28.5304 2 28 2H4ZM30 6.766L20.584 12.416L30 18.21V6.766ZM29.932 20.518L18.652 13.576L16 15.166L13.348 13.576L2.068 20.516C2.18165 20.9416 2.43263 21.3178 2.78198 21.5861C3.13133 21.8544 3.55949 21.9999 4 22H28C28.4402 22.0001 28.8682 21.8548 29.2175 21.5869C29.5668 21.3189 29.818 20.9432 29.932 20.518ZM2 18.21L11.416 12.416L2 6.766V18.21Z"
      fill={color}
    />
  </svg>
)

export default EnvelopeIcon
